import { Layout } from 'antd';
import CustomHeader from './CustomHeader.js';
import CustomFooter from './CustomFooter.js';
import Routes from './Routes.js';

// const { Content } = Layout;


function Main() {
  return (
    <Layout>
      <CustomHeader/>
      <Routes/>
      <CustomFooter/>
    </Layout>
  );
}

export default Main;
